(ns machtfit.datetime
  (:require [cljs-time.coerce :as time.coerce]
            [cljs-time.core :as time]
            [cljs-time.format :as time.format]
            [machtfit.human :as human]
            [machtfit.translation :refer [str-tr t]]))

(defn unix->date [unix-date]
  (-> unix-date
      time.coerce/from-long
      time/to-default-time-zone))

(defn string->date [human-str]
  (some->> human-str human/human->date (apply time/local-date)))

(defn get-year [date-time]
  (time/year date-time))

(defn format-date
  "Format a date value for German human consumption."
  [date]
  (when date
    (time.format/unparse (time.format/formatter "dd.MM.yyyy") date)))

(defn format-datetime
  "Format a date-time value for German human consumption."
  [date-time]
  (when date-time
    (time.format/unparse (time.format/formatter "dd.MM.y, HH:mm") date-time)))

(defn inst->iso-weekday
  "Weekday of a js/Date as ISO 1-7, Monday to Sunday; getDay numbers Sunday 0."
  [inst]
  (let [js-weekday (.getDay inst)]
    (if (zero? js-weekday) 7 js-weekday)))

(defn format-long-weekday
  "Format a date-time value to weekday number."
  [date-time]
  (when date-time
    (-> date-time
        time/day-of-week
        human/weekdays
        :long)))

(defn format-short-weekday
  "Format a date-time value to weekday number."
  [date-time]
  (when date-time
    (-> date-time
        time/day-of-week
        human/weekdays
        :short)))

(defn format-month-name
  "Format a date value to month name."
  [date]
  (some-> date
          human/month-name))

(defn format-appointment
  "Format a date-time value to appointment for human consumption."
  [date-time]
  (when date-time
    (str-tr (format-long-weekday date-time) " " (format-datetime date-time))))

(defn format-appointment-date
  "Format a date-time value to appointment day for human consumption."
  [date-time]
  (when date-time
    (str-tr (format-long-weekday date-time) " " (format-date date-time))))

(defn format-time
  "Format a date-time value to time for human consumption."
  [date-time]
  (when date-time
    (time.format/unparse (time.format/formatter "HH:mm") date-time)))

(defn format-weekday-time
  "Format a date-time value to weekday and time for human consumption."
  [date-time]
  (when date-time
    (str-tr (format-long-weekday date-time) " " (format-time date-time))))

(defn iso-date-string? [s]
  (let [formatter (time.format/formatter "yyyy-MM-dd")]
    (try
      (time.format/parse formatter s)
      true
      (catch js/Error _
        false))))

(defn iso-date->date [date]
  (some->> date (time.format/parse-local-date (time.format/formatter "yyyy-MM-dd"))))

(defn iso-date->date-string [date]
  (some->> date
           iso-date->date
           format-date))

(defn iso-time->time-string [time]
  (some->> time
           ;; the ISO time format happens to be readable by human->time as well
           machtfit.human/human->time
           human/timeformat))

(defn iso-datetime->datetime
  "Parse an ISO datetime string (e.g., from Python's isoformat()) into a cljs-time datetime object."
  [datetime-str]
  (when datetime-str
    (time.format/parse (time.format/formatters :date-time) datetime-str)))

(defn iso-datetime->datetime-string
  "Parse an ISO datetime string and format it for German human consumption (dd.MM.y, HH:mm)."
  [datetime-str]
  (some->> datetime-str
           iso-datetime->datetime
           format-datetime))

(defn date->iso-date [date]
  (when date
    (time.format/unparse (time.format/formatter "yyyy-MM-dd") date)))

(defn date-string->iso-date [human-str]
  (some->> human-str string->date date->iso-date))

(defn date-string->utc-date [human-str]
  (some->> human-str human/human->date (apply time/date-time)))

(defn date->inst [date]
  (js/Date. date))

(defn today-in-period? [start end]
  (and (time/before? start (time/now))
       (time/after? end (time/now))))

(defn countdown-active? [end-at countdown-factor]
  (let [start-at (time/minus end-at countdown-factor)]
    (today-in-period? start-at end-at)))

(defn create-date [year month day]
  (time/date-time year month day))

#_{:clj-kondo/ignore [:clojure-lsp/unused-public-var]}
(defn format [date-time format-string]
  (when date-time
    (time.format/unparse (time.format/formatter format-string) date-time)))

(defn month-and-year [date]
  (str (t (format-month-name date)) " " (some-> date get-year)))
